import Swiper, { Navigation, Pagination } from "swiper";

export function blockTextMedia() {
  new Swiper(".text-media__swiper", {
    modules: [Navigation, Pagination],
    direction: "horizontal",
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
}
